export default "__VITE_ASSET__Bw$jBmye__"